/* Small, progressive motion layer. Normal navigation remains the fallback. */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const reveal = root => {
    if (reduced.matches) return;
    const targets = root.querySelectorAll('.th-head,.th-cat,.th-edit-card,.th-spot__info,.th-benefit,.th-collection-edit__copy,collection-component product-card');
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('th-motion-in');
        observer.unobserve(entry.target);
      });
    },{threshold:.12});
    targets.forEach((el,i) => {
      if (el.dataset.thMotion) return;
      el.dataset.thMotion='ready';
      el.style.animationDelay=`${Math.min(i % 5,4)*60}ms`;
      observer.observe(el);
    });
  };
  const init = () => {
    reveal(document);
    const sweep=document.createElement('div');
    sweep.className='th-nav-sweep';
    sweep.setAttribute('aria-hidden','true');
    sweep.textContent='TRENDORA';
    document.body.append(sweep);
    let navigating=false;
    document.addEventListener('click', event => {
      const link=event.target.closest('a[href]');
      if (!link || reduced.matches || event.defaultPrevented || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target || link.hasAttribute('download')) return;
      const url=new URL(link.href,location.href);
      if (url.origin!==location.origin || !url.pathname.startsWith('/collections/') || url.pathname===location.pathname || navigating) return;
      event.preventDefault();
      navigating=true;
      document.body.classList.add('th-is-leaving');
      window.setTimeout(() => location.assign(url.href),270);
    });
    window.addEventListener('pageshow',() => {navigating=false;document.body.classList.remove('th-is-leaving');});
    document.addEventListener('shopify:section:load',event=>reveal(event.target));
    document.addEventListener('results:updated',()=>reveal(document));
  };
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
